import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom"
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';

export const SearchTable = () => {
  const { filesList } = useSelector((state) => state.files);
  const columns = [
    {
      name: "#Exp",
      selector: row => [row.id],
      sortable: true, 
      width:"85px",
      cell: row => <span className="text-center w-100">
        <OverlayTrigger placement="top" overlay={<Tooltip >Ver Expediente</Tooltip>}>
          <Link to={row.group2 ? `/panel/expedienteIndividual?id=${row.id2}` : `/panel/expediente?id=${row.id2}`} 
            className="btn btn-primary btn-sm rounded-11 me-2" ><span className="fs-15 fw-semibold text-center">{row.id2}</span></Link>
        </OverlayTrigger>
      </span>
    },
    {
      name: "Venta",
      selector: row => [row.sale],
      sortable: true, 
      width:"100px",
      cell: row => <span className="text-center w-100">
        {row.sale === 0 ? <i className="fa fa-check" /> : ""}
      </span>
    },
    {
      name: "Categoria",
      selector: row => [row.category],
      sortable: true, 
      width:"100px",
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.category}</span>
    },
    {
      name: "Fecha",      
      selector: row => [row.requestDate],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.requestDate}</span>
    },
    {
      name: "Estatus",
      selector: row => [row.status],
      sortable: true,
      cell: row => <span className={`text-${row.status ==="Saldo" ? "yellow" : "green" } fs-15 fw-semibold text-center w-100`}>{row.status}</span>
    },
    {
      name: "Agente",
      selector: row => [row.agent],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.agent}</span>
    },
    {
      name: "Medio",
      selector: row => [row.contactWay],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.contactWay}</span>
    },
    {
      name: "Cliente",
      selector: row => [row.customer],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.customer}</span>
    },
    {
      name: "Grupo",
      selector: row => [row.group2],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.group2}</span>
    },
    {
      name: "Notas",
      selector: row => [row.notes],
      sortable: true,
      cell: row => <span className="text-center w-100">
        {row.notes && <i className="fa fa-check" />}
      </span>
    },
    {
      name: "#Cot",
      selector: row => [row.quotes],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.quotes}</span>
    },
    {
      name: "Tel",
      selector: row => [row.cellphone],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.cellphone}</span>
    },
    {
      name: "Fecha Inicio",
      selector: row => [row.startDate],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.startDate}</span>
    },
    {
      name: "Reserva",
      selector: row => [row.reserve],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.reserve}</span>
    },
  ]
  const tableDatas = {
    columns,
    data:filesList,
  };
  return (
    <DataTableExtensions {...tableDatas} >
      <DataTable
        columns={columns}
        data={filesList}
        noHeader
        defaultSortField="id"
        defaultSortAsc={false}
        striped={true}
        center={true}
        persistTableHead
        pagination
        highlightOnHover />
    </DataTableExtensions>
  )
}